
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HomeBanner',{attrs:{"page":'Home'}}),_c('HkPromotion')],1)}
var staticRenderFns = []

import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  render,
  staticRenderFns,
  _scopeId: 'data-v-37b18572',
  components: {
    HomeBanner: () => import('@/components/base/mobile/InsBanner.vue'),
    HkPromotion: () => import('@/components/hkTasteBusiness/mobile/home/HkPromotion.vue')
  }
})
export default class InsHome extends Vue {
  swiperOption: object = {
    autoplay: {
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  };

  get AreaCode () {
    return localStorage.getItem('AreaCode') || '';
  }
}
